import React from 'react';

class TinyRemainItem extends React.Component {
  static displayName = 'TinyRemainItem';
  static proptypes = {
    dishName: React.PropTypes.string,
    dishData: React.PropTypes.object,
    dishMarketPrice: React.PropTypes.number,
    orderBtn: React.PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      nextProps.dishData !== this.props.dishData
    );
  }

  render() {
    const { dishName, dishMarketPrice, orderBtn } = this.props;
    return (
      <li className="tiny-remainaddon-li o-flex">
        <span className="tiny-remainaddon-name o-flex__fluid">{dishName}</span>
        <span className="tiny-remainaddon-price o-flex__fixed o-fz--17 price">
          {dishMarketPrice}
        </span>
        <span className="tiny-remainaddon-counter o-flex">{orderBtn}</span>
      </li>
    );
  }
}

export default TinyRemainItem;



// WEBPACK FOOTER //
// ./src/component/dish-menu/cart/tiny-remain-item.jsx